import Vue from 'vue';

export const thousandNumberFormat = {
    bind(el, binding, vnode) {
        let langString = (el.lang == "pl") ? " " : "."
        el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, langString);
    },
    update(el, binding, vnode) {
        let langString = (el.lang == "pl") ? " " : "."
        el.innerHTML = binding.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, langString);
    }
}

Vue.directive('thousand-number', thousandNumberFormat)


// WEBPACK FOOTER //
// ./src/scripts/directives/thousandNumberFormatDirective.js